import {
  CheckCircleIcon,
  EllipsisHorizontalCircleIcon,
  ExclamationCircleIcon,
} from '@heroicons/react/20/solid';
import { gitRepoStateToString } from '../../helpers/util';

interface GitRepoStateBadgeProps {
  state: number;
}

export function GitRepoStateBadge(props: GitRepoStateBadgeProps) {
  return (
    <span className="flex items-center text-sm text-gray-500">
      {gitRepoStateToString(props.state) === 'Connected' && (
        <CheckCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-green-400"
          aria-hidden="true"
        />
      )}
      {gitRepoStateToString(props.state) === 'Disconnected' && (
        <ExclamationCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-red-400"
          aria-hidden="true"
        />
      )}
      {gitRepoStateToString(props.state) === 'Pending' && (
        <EllipsisHorizontalCircleIcon
          className="mr-1.5 h-5 w-5 flex-shrink-0 text-gray-400"
          aria-hidden="true"
        />
      )}
      {gitRepoStateToString(props.state)}
    </span>
  );
}
